// 项目信息化评审
export default [

    {
        path: '/sys/expertInfo',
        name: 'sys_expertInfo',
        component: () => import('@/views/sys/expert/expertInfo'),
        meta: {title: "专家信息", requireLogin: true}
    },
    {
        path: '/sys/expertAudit',
        name: 'sys_expertAudit',
        component: () => import('@/views/sys/expert/expertAudit'),
        meta: {title: "专家审核", requireLogin: true}
    },
    {
        path: '/sys/expert/registered',
        name: 'sys_registered',
        component: () => import('@/views/sys/expert/registered'),
        meta: {title: "专家信息", requireLogin: true}
    },
    {
        path: '/sys/expert/resultAudit',
        name: 'sys_result_audit',
        component: () => import('@/views/sys/expert/resultAudit'),
        meta: {title: "评审资料补充审核", requireLogin: true}
    },
    {
        path: '/sys/govInstitution',
        name: 'sys_govInstitution',
        component: () => import('@/views/sys/govInstitution/govInstitutionInfo'),
        meta: {title: "事业单位信息", requireLogin: true}
    },
    {
        path: '/sys/application/info',
        name: 'sys_application_info',
        component: () => import('@/views/sys/application/info'),
        meta: {title: "项目评审申请", requireLogin: true}
    },
    {
        path: '/sys/application/resultAudit',
        name: 'sys_application_audit',
        component: () => import('@/views/sys/application/resultAudit'),
        meta: {title: "项目评审审核", requireLogin: true}
    },
]
